
import { Component, Injector } from '@angular/core';
import { DeliverablesService, RequestTypeService } from '../../ve.service';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { Validators } from '@angular/forms';
import { FilterableService } from '../../filterable-service';

@Component({
  selector: 'app-deliverables',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class DeliverablesComponent extends BaseGridComponent {
  public descMaxLength: number = null;
  private readonly bodyRequestTypeService: RequestTypeService;
  private readonly requestTypeService = new FilterableService();

  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: DeliverablesService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.bodyRequestTypeService = injector.get(RequestTypeService);
    this.descMaxLength = 50;
    this.appCardTitle = 'Deliverables';
    this.path = '/?activeOnly=false';

    this.columns = [
      {
        field: 'Description',
        title: 'Description',
      },
      {
        field: 'RequestTypeDescription',
        title: 'Request Type',
        type: 'dropdown',
        service: this.requestTypeService,
        textField: 'Description',
        valueField: 'Id',
        name: 'RequestTypeId',
        refreshSecondaryData: this.populateRequestTypeList,
      },
      {
        field: 'IncludeInTemplate',
        title: 'Available for Multiple Work Orders',
        editor: 'boolean',
        filter: 'boolean'
      },
      {
        field: 'IsActive',
        title: 'Active',
        editor: 'boolean',
        filter: 'boolean'
      },
    ];

    this.editForm = this.formBuilder.group({
      Id: [],
      Description: ['', Validators.required],
      RequestTypeDescription: [],
      RequestTypeId: ['', Validators.required],
      IsActive: [],
      IncludeInTemplate: [],
      AuditDto: []
    });
  }

  populateRequestTypeList(dataItem: any) {
    dataItem.bodyRequestTypeService.read('?activeOnly=true')
    .then(result => {
      if (result.length > 0) {
        result.sort((a, b) => a.Description.localeCompare(b.Description));
      }
      dataItem.requestTypeService.next(result);
    });
  }
}
